const WELLTRAVEL = 'welltravel';

export default WELLTRAVEL;
